import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import { InputTypes } from '../../utils/validateFormElement';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

class AuthorityFinder extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-authority-finder u-pb-1">
				<div class="lta-authority-finder-title u-hidden">${titleMarkup}</div>
                <div class="lta-authority-finder--search-input-wrapper">
					<div class="lta-authority-finder--search-input u-mb-2"></div>
				</div>
				<div class="lta-authority-finder--search-result u-hidden"></div>
            </div>
        `;
	}
	afterRender() {
		this.authorityFinderElement = SelectorEngine.findOne('.lta-authority-finder', this.containerEl);
		this.authorityFinderTitle = SelectorEngine.findOne('.lta-authority-finder-title', this.authorityFinderElement);
		this.authorityFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-authority-finder--search-input-wrapper',
			this.authorityFinderElement
		);
		this.parkFinderSearchInput = SelectorEngine.findOne(
			'.lta-authority-finder--search-input',
			this.authorityFinderSearchInputWrapper
		);
		this.authorityFinderSearchResult = SelectorEngine.findOne(
			'.lta-authority-finder--search-result',
			this.authorityFinderElement
		);

		this.initSearchInputField();
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.parkFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.venueName,
				dataKey: this.data.dataKey,
				dataValue: item.id
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.id === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadAuthorityResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadAuthorityResult(this.data?.value, false);
		}
	}
	loadAuthorityResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.venueName) {
			return;
		}
		this.authorityFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.authorityFinderTitle.classList.remove(HIDDEN_CLASS);
		this.authorityFinderSearchResult.classList.remove(HIDDEN_CLASS);
		this.authorityFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.authorityFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-authority-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, CLICK_EVENT, () => {
			this.value = undefined;
			suggestionAutoSuggestResult.remove();
			this.searchInputTextField.remove();
			this.initSearchInputField();
			this.authorityFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.authorityFinderTitle.classList.add(HIDDEN_CLASS);
			this.authorityFinderSearchResult.classList.add(HIDDEN_CLASS);
		});
	}
	renderAutoSuggestResult(parkDetail) {
		return `<div class="lta-autosuggest-input-result u-mb-4">
					<div class="u-mb-4">
						${this.renderInstructionLabel(this.data.instructionText)}
					</div>
					${!this.data?.resultTitleNotVisible ? `<div class="lta-text-input__label">Your ${this.data.venueType}</div>` : ''}
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_park-name u-h6 u-mb-1">${parkDetail.venueName}</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-authority-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
							</svg>Remove ${this.data.venueType}
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		this.searchInputTextField.validate(true);
		if (this.parkAddressSearch) {
			this.parkAddressSearch.validate();
		}
	}
}
export default AuthorityFinder;
